<template>
  <!-- FI-2172 the Event Response Manager settings page. the body is
       ops_desk_settings.vue in page mode, where the window is the scroll
       container and the shell's chrome (the tab banner, the sidebar) is its
       header. since 2026-10-01 this is the only home for ERM settings: the
       ERM menu's Settings row opens it, and the settings modal the Event Log
       and Event Board used to mount (erm_settings_modal.vue) retired, its old
       links redirected here (router/index.js ermSettingsQuery). this host is
       the settings shell's tab contract and nothing else:
       isDirty for the unsaved-changes guard (beforeRouteLeave, beforeunload,
       the tab switch), load_data for the silent refresh on arrival and the
       discard on leave, scrollToFirstDirtyField for "Stay on this page". the
       body keeps its own window.confirm guard for section moves inside it.
       under classic (site_theme original) the shell still mounts its own left
       rail beside the body's section rail; the body narrows its rail there
       (ops_desk_settings.vue, the page-mode css) so the two read as rail and
       sub-rail. horizon and midnight never mount the shell rail. under
       horizon/midnight the shell's FiPageRail is the body's header (the
       place, its back, its Discard + Save; on a phone the body drills in, a
       list of sections, one open at a time): rail relays the body's header
       up, railBack and railAction hand the clicks down. -->
  <div class="tc-erm">
    <ops-desk-settings page :initial-tab="initialTab" ref="body" @dirty="onDirty" @rail="$emit('rail', $event)" />
  </div>
</template>

<script>
import OpsDeskSettings from './ops_desk_settings.vue'

export default {
  name: 'tenant_config_erm',
  components: { OpsDeskSettings },
  data() {
    return {
      // the body's anyDirty, mirrored through its dirty event so the shell
      // reads a plain flag like every other tab's isDirty
      dirty: false,
    }
  },
  computed: {
    isDirty() {
      return this.dirty
    },
    // ?settings_tab=<section id> lands on a section, 'distribution' on the
    // Every category page (the huddle panel's links, the empty log's public
    // form button, old modal links); undefined lets the body's own default
    // (General, the list on a phone) apply. read at mount.
    initialTab() {
      const q = (this.$route && this.$route.query) || {}
      return q.settings_tab ? String(q.settings_tab) : undefined
    },
  },
  methods: {
    onDirty(val) {
      this.dirty = !!val
    },
    // the shell's refresh on arrival (silent) and discard on leave (loud):
    // the body's own mount hydration, one composite GET that re-baselines
    // every section. silent keeps the rail, the sections and an open category
    // page in place while the data refetches, the way every other tab's
    // load_data(true) refetches without disturbing the ui; loud shows the
    // body's loading state and closes an open page. the ref is the only thing
    // guarded: loadAll is the body's seam and a missing one should fail loudly.
    load_data(silent) {
      const body = this.$refs.body
      if (!body) return
      return body.loadAll(!!silent)
    },
    // the shell's FiPageRail back (a section on a phone, a category page)
    railBack() {
      const body = this.$refs.body
      if (body) body.headerBack()
    },
    // one of the header's actions (the open place's Discard / Save)
    railAction(id) {
      const body = this.$refs.body
      if (body) body.headerAction(id)
    },
    // "Stay on this page" after the unsaved-changes dialog: bring the body
    // (its rail carries the dirty dot) back into view. the document's
    // scroll-padding-top (the settings shell's syncRailHeight) keeps it clear
    // of the fixed Horizon top bar and the pinned header.
    scrollToFirstDirtyField() {
      const el = this.$el
      if (el && el.scrollIntoView) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
    },
  },
}
</script>

